import { transportationKeys } from '../consts/conditions';
import { useArithmetic } from './transformations/useArithmetic';
import useDefaultTransformation from './transformations/useDefaultTransformation';

interface UseTransformationProps {
  type: string;
  [key: string]: unknown;
}

export default function useTransformation(props: UseTransformationProps): any {
  const transformationType = props.type;

  switch (transformationType) {
    case transportationKeys.CONCATENATE:
    case transportationKeys.ARITHMETIC:
      return useArithmetic(props);

    default:
      return useDefaultTransformation(props);
  }
}
